import { useEffect, useState } from "react";
import { motion } from "framer-motion";

/**
 * Brief intro curtain. It counts to 100 over ~1.1s, then lifts away — long
 * enough to feel intentional, short enough not to annoy a returning visitor.
 */
const Preloader = ({ onDone }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const step = setInterval(() => {
      setCount((value) => {
        if (value >= 100) {
          clearInterval(step);
          return 100;
        }
        return Math.min(100, value + Math.ceil(Math.random() * 9));
      });
    }, 45);

    return () => clearInterval(step);
  }, []);

  useEffect(() => {
    if (count < 100) return undefined;
    const timeout = setTimeout(() => onDone?.(), 350);
    return () => clearTimeout(timeout);
  }, [count, onDone]);

  return (
    <motion.div
      exit={{ y: "-100%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
    >
      <div className="grain absolute inset-0 opacity-40" />

      <motion.h1
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="display relative text-5xl text-cream sm:text-6xl"
      >
        Albina<span className="text-sage">.</span>
      </motion.h1>

      <div className="relative mt-8 h-px w-56 overflow-hidden bg-cream/15">
        <motion.div
          className="h-full bg-sage"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: count / 100 }}
          style={{ originX: 0 }}
          transition={{ ease: "linear", duration: 0.15 }}
        />
      </div>

      <p className="relative mt-4 font-mono text-xs tracking-[0.3em] text-cream/40">
        {String(count).padStart(3, "0")}
      </p>
    </motion.div>
  );
};

export default Preloader;
